/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Warning } from '@mui/icons-material';
import { ProviderName } from '../ProviderEnum';

interface Props {
  featureDisabled: boolean;
  providerLinked: boolean;
  gameOwned: boolean;
  provider: ProviderName;
}

export function ProviderMergeWarning({ featureDisabled, providerLinked, gameOwned, provider }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <div className='warning-msg'>
        <Warning className='icon warning' />
        {featureDisabled && (
          <span>{t('translation:account.provider.mergeDisabledWarning')}</span>
        )}
        {!featureDisabled && !providerLinked && (
          <span>{t('translation:account.provider.linkBeforeMergeWarning', { provider: t(provider) })}</span>
        )}
        {!featureDisabled && providerLinked && !gameOwned && (
          <span>{t('translation:account.provider.gameNotOwnedMergeWarning', { provider: t(provider) })}</span>
        )}
      </div>
    </>
  );
}
